import { Page } from '$lib/utils/page';
import { browser } from '$app/environment';
import { policy, policyExceptionHandler } from '../routes/_home/-policy';
import { pageConditions } from '../routes/_home/__config/conditions';
import { get } from 'svelte/store';
import { user } from '$lib/stores/user/store';
import { logout } from '$lib/stores/user/action';
import { app } from '$lib/stores/app/store';
import { AppInitializationService } from '$lib/services/app-initialization';

export const prerender = true;

/**
 * Loads metadata for the page.
 * @returns {Promise<{metadata: object, page?: Page}>} Page object with conditions and metadata, or undefined if not in browser
 */
export async function load() {
	const metadata = {
		link: [
			{
				href: 'https://www.abcmouse.com/abc/',
				rel: 'canonical',
			},
			{
				href: 'https://www.abcmouse.com',
				hreflang: 'en',
				rel: 'alternate',
			},
			{
				href: 'https://www.abcmouse.com/es',
				hreflang: 'es',
				rel: 'alternate',
			},
		],
		metaTag: [
			{
				content: 'https://www.abcmouse.com/abc/images/ABCmouse_Homepage_Preview.png',
				name: 'twitter:image',
			},
			{
				content: 'https://www.facebook.com/ABCmouse/',
				property: 'article:publisher',
			},
			{
				content: 'https://www.abcmouse.com/assets-mkt/routes/home/learning_path_v1_2x.png',
				property: 'og:image',
			},
			{
				content: '827',
				property: 'og:image:height',
			},
			{
				content: 'https://www.abcmouse.com/assets-mkt/routes/home/learning_path_v1_2x.png',
				property: 'og:image:secure_url',
			},
			{
				content: '1268',
				property: 'og:image:width',
			},
			{
				content: 'ABCmouse | Early Learning for Ages 2–8',
				property: 'og:site_name',
			},
			{
				content: 'https://www.abcmouse.com/abc/',
				property: 'og:url',
			},
		],
		title: 'ABCmouse: Educational Games, Books, Puzzles & Songs for Kids & Toddlers',
	};

	if (browser) {
		await AppInitializationService.waitForInitialization();
		const userLoggedInAndValid = get(user) && get(user)?.tokenValid;

		const shouldLogoutBrowser = userLoggedInAndValid && document.referrer.includes('html5');
		const shouldLogoutInApp = userLoggedInAndValid && get(app).meta.inApp;

		const shouldLogout = shouldLogoutBrowser || shouldLogoutInApp;
		if (shouldLogout) {
			await logout(get(app), { redirect: false });
		}

		const page = new Page({
			routePath: '/',
			metadata,
			policies: { policy, policyExceptionHandler },
			conditions: pageConditions,
		});

		return {
			metadata: page.metadata,
			page,
		};
	}

	const resolvedMetadata = new Page({ routePath: '/', metadata }).metadata;
	return {
		metadata: resolvedMetadata,
	};
}
